import { Typography, Button } from "antd";
import { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { AppState } from "store";
import {deleteVehicle, remoteLockVehicle, setModalName} from "store/actions";

const { Text, Title } = Typography;

export default function RemoteLockForm() {
    const dispatch = useDispatch();
    const { selectedVehicle } = useSelector<AppState, AppState["vehicles"]>(
        (state) => state.vehicles
    );

    const onRemoteLock = useCallback(() => {
        dispatch(remoteLockVehicle(selectedVehicle?.id || "", selectedVehicle?.isRemoteLock ? "ON" : "OFF"))
        onCancel();
    }, [dispatch, selectedVehicle?.id]);

    const onCancel = useCallback(() => {
        dispatch(setModalName(undefined));
    }, [dispatch]);
    //{vehicle?.isRemoteLock ? "Turn Vehicle ON" : "Turn Vehicle OFF"}
    return (
        <section className="delete-modal">
            <Title level={5}>Vehicle Remote Lock/Unlock</Title>
            <Text type="secondary">
                Are you sure {selectedVehicle?.isRemoteLock ? "to turn remote vehicle on?" : "to turn remote vehicle off"}
                <strong> “{selectedVehicle?.licensePlate}”</strong> ?
            </Text>
            <div className="action-btn-container">
                <Button className="cancel-btn" onClick={onCancel}>
                    Cancel
                </Button>
                <Button type="primary" danger onClick={onRemoteLock}>
                    {selectedVehicle?.isRemoteLock ? "Turn Vehicle ON" : "Turn Vehicle OFF"}
                </Button>
            </div>
        </section>
    );
}
